export const inputWidths = ['sm', 'md', 'lg', 'max'] as const
export type InputWidth = (typeof inputWidths)[number]

export const inputWidth: Record<InputWidth, number | string> = {
  lg: 450,
  max: '100%',
  md: 350,
  sm: 150,
}
